import { ModalLicenseAgreement } from "../components/modal-license-agreement";
import { ContextModalLicenseAgreementProvider } from "../context/index";
import { ModalLicenseAgreementProps } from "../types/index";

export default function LayoutModalLicenseAgreement(
  props: ModalLicenseAgreementProps,
) {
  return (
    <>
      <ContextModalLicenseAgreementProvider {...props}>
        <ModalLicenseAgreement />
      </ContextModalLicenseAgreementProvider>
    </>
  );
}
